import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getPayingCustomer, getTrialEndDate } from '@/api/rtk/userSelectors'

function computeDaysLeft(trialEndDate) {
  if (!trialEndDate) return null;
  const currentDate = new Date();
  const endDate = new Date(trialEndDate);
  return Math.ceil((endDate - currentDate) / (1000 * 60 * 60 * 24));
}

export function computeTrialEnded(payingCustomer, trialEndDate, daysLeft) {
  if (payingCustomer !== false) return false;
  if (!trialEndDate) return true;
  return daysLeft !== null && daysLeft <= 0;
}

export function useSubscription() {
  const trialEndDate = useSelector(getTrialEndDate);
  const payingCustomer = useSelector(getPayingCustomer);

  const daysLeft = useMemo(
    () => computeDaysLeft(trialEndDate),
    [trialEndDate]
  );

  const trialEnded = useMemo(
    () => computeTrialEnded(payingCustomer, trialEndDate, daysLeft),
    [payingCustomer, trialEndDate, daysLeft]
  );

  return {
    daysLeft,
    trialEnded,
    hasActiveSubscription: !trialEnded,
  };
}
